import Form from 'Components/Forms/FormGenerator';
import FormViewer from 'Components/FormViewer';
import { actions as measurementActions } from 'ducks/measurements';
import React from 'react';
import { useSelector } from 'react-redux';
import { metadataFields, serializeForm } from 'utils/forms/utils';
import { getMeasurementMetadata } from 'utils/getMetadata.js';

const Component = props => {
    const { device, readingId } = props;
    const { closeDrawer } = props;

    const submitting = useSelector(state => state.measurements.submitting);

    const rootDevice = useSelector(state => state.devices.models[device.root_device_id]);
    const metadata = getMeasurementMetadata(device, rootDevice);

    const formSchema = [
        {
            type: 'text',
            label: 'Name\x2a',
            name: 'name'
        },
        ...metadataFields(metadata)
    ];

    const create = measurementActions.useCreate();
    const onSubmit = formValues => {
        let data = {
            ...serializeForm(formValues, formSchema),
            device_id: device.id,
            reading_id: readingId
        };

        create(data, closeDrawer);
    };

    return (
        <FormViewer label="Add Measurement">
            <Form
                formSchema={formSchema}
                isSubmitting={submitting}
                onSubmit={onSubmit}
            />
        </FormViewer>
    );
};

export default Component;
